import { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import FixedConsultationForm from "./FixedConsultationForm";
import LandingHomePC from "./LandingHomePC";
import LandingHomeMO from "./LandingHomeMO";
import PopupComponent from "./PopupComponent";
import Sidenav from "./SideNav";
import As from "./As";

function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 800);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Router>
      <div>
        <Routes>
          <Route
            path="/"
            element={
              <>
                {isMobile ? <LandingHomeMO /> : <LandingHomePC />}
                <PopupComponent /> {/* 팝업은 메인페이지에서만 노출 */}
              </>
            }
          />
          <Route path="/as" element={<As />} />
          {/* 다른 라우트들을 여기에 추가할 수 있습니다 */}
        </Routes>
        <FixedConsultationForm />
        <Sidenav />
        <div style={{ height: "200px" }}></div>
      </div>
    </Router>
  );
}

export default App;